import { render, staticRenderFns } from "./EducationLevel.vue?vue&type=template&id=3e1bfe90&scoped=true"
import script from "./EducationLevel.vue?vue&type=script&lang=js"
export * from "./EducationLevel.vue?vue&type=script&lang=js"
import style0 from "./EducationLevel.vue?vue&type=style&index=0&id=3e1bfe90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1bfe90",
  null
  
)

export default component.exports